import { Injectable } from '@angular/core';
import { FirebaseStorage } from '../../../providers/firebase-storage';
//import { Observable } from 'rxjs/Observable';
import { FireBaseObjectNames } from '../../../core/codes';
import { AppSettings } from '../../../config/app-settings';
import { Storage } from '@ionic/storage';
import firebase from 'firebase';
import { ElasticSearchService } from '../../../providers/elastic-search';
import { AngularFireDatabaseWrapper } from '../../../providers/angularfire-wrapper';


@Injectable()
export class AboutUsData {
    public realtimeDb: any;
    //private userRecipes = [];
    constructor(
        private firebaseStorage: FirebaseStorage,
        public settings: AppSettings,
        private storage: Storage,
        public elasticSearchService: ElasticSearchService,
        public afw: AngularFireDatabaseWrapper,
    ) {
        this.realtimeDb = firebase.database();
    }
    
    public getAllCategories() {
        let strgRef = FireBaseObjectNames.RECIPE_CATEGORIES;
        var result = this.afw.list(strgRef).map(val => {
            this.storage.set(strgRef, JSON.stringify(val));
            return val;
        });
        return result;
    }
    public getCategoriesByRecipeId(recipeId) {
        console.log(recipeId);
        let strgRef = FireBaseObjectNames.RECIPES + '/' + recipeId + '/categories';//FireBaseObjectNames.RECIPE_CATEGORIES;
        var result = this.afw.list(strgRef).map(val => {
            return val;
        });
        return result;
    }
}


// WEBPACK FOOTER //
// ./src/modules/about-us/providers/about-us-data.ts